import { Analytics } from "analytics";
import googleAnalytics from "@analytics/google-analytics";
class GoogleAnalytics {
    static ANALYTICS_KEY = [`${process.env.GTAG}`];
    analytics;
    constructor() {
        this.analytics = Analytics({
            app: "portfolio",
            version: 100,
            plugins: [
                googleAnalytics({
                    measurementIds: GoogleAnalytics.ANALYTICS_KEY,
                }),
            ],
        });
    }
    trackPage() {
        this.analytics.page();
    }
}
export default GoogleAnalytics;
